import { useThemeStore } from "@stores/theme.store";
import { Button, Select, Tag } from "antd";
import moment from "moment-timezone";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { linkPage } from "@utils/router";
import { useQuery } from "@tanstack/react-query";
import { SchoolService } from "@services/school.service";
import { FcFinePrint } from "react-icons/fc";
import { Spiner } from "@components/loaders/spiner";
import { PermitService } from "@services/permit.service";
import { Permit } from "@services/dtos/permit.dto";
import { FilterOutlined } from "@ant-design/icons";
import { PopupCustom } from "@components/general/popup";
import { FilterButton } from "@components/general/filter_button";
moment.locale("id");

export const PermitDataPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");
  const [popupFilter, setPopupFilter] = useState<boolean>(false);

  const { data: dataNis } = useQuery({
    queryKey: [SchoolService.queries.GET_SCHOOL_STUDENT_BIO],
    queryFn: SchoolService.studentBio,
  });
  const nis = dataNis?.data?.nis ?? "";

  const {
    data,
    isPending: isPendingPermitData,
    // refetch: refetchPermitData,
  } = useQuery({
    queryKey: [PermitService.queries.GET_PERMIT_DATA, nis, limit],
    queryFn: () => PermitService.data({ nis, limit }),
  });

  const onOpenDetail = (data: Permit) => {
    navigate(linkPage.PERMIT_DETAIL_PAGE, { state: data });
  };

  useEffect(() => {
    setAppBar({ title: "Data Perizinan", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Data Perizinan",
      image: false,
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pt-2 tw-pb-20">
        <>
          {/* set filter */}
          <FilterButton
            limit={limit}
            text="data terakhir"
            onFilterClick={() => setPopupFilter(true)}
          />
          {/* end of set filter */}

          {/* report */}
          <div className="tw-mt-8">
            {isPendingPermitData ? (
              <div className="tw-text-center card-body">
                <Spiner />
              </div>
            ) : data?.data != null && data.data.length > 0 ? (
              <>
                {data.data.map((item, idx) => (
                  <div
                    key={idx}
                    className="tw-mb-4 tw-py-2 card-body"
                    onClick={() => onOpenDetail(item)}
                  >
                    <div className="tw-flex tw-justify-between tw-items-center tw-font-semibold">
                      <div className="tw-font-medium tw-text-accent-primary">
                        {item.acc === "Y" && (
                          <Tag color="green" className="tw-text-[10px] ">
                            Diizinkan
                          </Tag>
                        )}
                        {item.acc === "N" && (
                          <Tag color="red" className="tw-text-[10px]">
                            Tidak Diizinkan
                          </Tag>
                        )}

                        <Tag color="orange" className="tw-text-[10px]">
                          Sedang dikonfirmasi
                        </Tag>
                      </div>
                      <div className="tw-text-xs tw-font-medium tw-text-text-secondary">
                        Izin
                      </div>
                    </div>
                    <div
                      className="tw-pb-2 tw-mb-2 tw-flex tw-justify-between tw-items-end tw-font-semibold tw-border-primary"
                      style={{ borderBottom: "1px solid" }}
                    >
                      <div className="tw-text-sm">
                        {moment(item.datePermit ?? Date.now()).format(
                          "DD MMMM YYYY"
                        )}
                      </div>
                      <div className="tw-w-1/2 tw-text-end">
                        <div className="tw-text-base tw-text-text-primary">
                          {item.mode}
                        </div>
                      </div>
                    </div>

                    <div className="tw-text-xs tw-text-end tw-text-text-tertiary tw-italic">
                      klik untuk melihat detail
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="tw-p-8 tw-text-center card-body">
                <FcFinePrint size={50} />
                <div>Data tidak ditemukan</div>
              </div>
            )}
          </div>
          {/* end of report */}
        </>
      </div>

      <PopupCustom
        title="Filter Data"
        open={popupFilter}
        onCancel={() => setPopupFilter(false)}
        slideUpModal={true}
      >
        <div className="">
          <Select
            className=" tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e)}
            options={[
              { value: "10", label: "10 data terakhir" },
              { value: "25", label: "25 data terakhir" },
              { value: "50", label: "50 data terakhir" },
              { value: "100", label: "100 data terakhir" },
            ]}
          ></Select>
          <Button
            onClick={() => setPopupFilter(false)}
            className="tw-p-2 tw-mt-6 tw-h-10 tw-w-full tw-text-base tw-rounded-xl tw-bg-red-500 tw-text-background-200 focus:tw-shadow-none hover:tw-bg-background-200 hover:tw-text-accent-primary hover:tw-border-primary"
          >
            Tutup
          </Button>
        </div>
      </PopupCustom>
    </>
  );
};
